import React from 'react';
import { UsersIcon, AwardIcon, BookOpenIcon, HeartIcon, TrendingUpIcon, BarChart2Icon, GraduationCapIcon } from 'lucide-react';
import { MathsBadge } from '../shared/MathsBadge';
export function KeyBenefitsSection() {
  return <section id="key-benefits" className="py-20 bg-gradient-to-br from-purple-600 to-blue-600 text-white relative overflow-hidden" data-id="element-320">
      {/* Geometric shapes */}
      <div className="absolute top-0 left-0 w-40 h-40 bg-white opacity-5 rounded-br-full" data-id="element-321"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-white opacity-5 rounded-tl-full" data-id="element-322"></div>
      <div className="absolute top-1/2 left-1/4 w-20 h-20 bg-white opacity-5 rotate-45 animate-spin" style={{
      animationDuration: '15s'
    }} data-id="element-323"></div>
      <div className="absolute bottom-1/3 right-1/4 w-16 h-16 bg-white opacity-5 rounded-full animate-ping" style={{
      animationDuration: '10s'
    }} data-id="element-324"></div>
      {/* Math badges */}
      <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/k9qfpEeMdg27tDko21ZZB8/Donut.png" altText="Math Donut Badge" size="large" className="absolute top-10 right-10 z-10 hidden md:block" data-id="element-325" />
      <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/oSyFKMd1gXQJtJSr1mv7wj/Pumpkin_Pi.png" altText="Pumpkin Pi Badge" size="large" className="absolute bottom-10 left-10 z-10 hidden md:block" data-id="element-326" />
      <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/dMqtmYeS2ue9jsFt6XRLTH/Rainbow.png" altText="Rainbow Badge" size="large" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 hidden lg:block opacity-20" data-id="element-327" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-328">
        <div className="text-center mb-12" data-id="element-329">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-330">
            ❤️ Key Benefits for Your School
          </h2>
          <div className="w-24 h-1 bg-white/40 mx-auto mb-4" data-id="element-331"></div>
          <p className="text-lg text-white/90 max-w-2xl mx-auto" data-id="element-332">
            Join our research study and receive comprehensive support and
            resources for your KS3 maths teachers and students
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-333">
          {/* Benefit Card 1 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10 relative overflow-hidden group" data-id="element-334">
            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-bl-full -mr-12 -mt-12 group-hover:scale-110 transition-transform duration-500" data-id="element-335"></div>
            <div className="flex items-center mb-4" data-id="element-336">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-337">
                <UsersIcon className="w-6 h-6 text-white" data-id="element-338" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-339">Full Eedi Plus Access</h3>
            </div>
            <p className="text-white/90 mb-2" data-id="element-340">
              All participating KS3 teachers and students get premium access for
              the full academic year, including personalised learning tools and
              on-demand, live tutor support for every student.
            </p>
            <p className="text-white font-bold" data-id="element-341">Worth £000's</p>
          </div>
          {/* Benefit Card 2 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10 relative overflow-hidden group" data-id="element-342">
            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-bl-full -mr-12 -mt-12 group-hover:scale-110 transition-transform duration-500" data-id="element-343"></div>
            <div className="flex items-center mb-4" data-id="element-344">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-345">
                <AwardIcon className="w-6 h-6 text-white" data-id="element-346" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-347">£500 Payment</h3>
            </div>
            <p className="text-white/90" data-id="element-348">
              Financial reward for your school's commitment to the RCT and
              participation in research activities. Funds can be used for any
              educational purpose.
            </p>
          </div>
          {/* Benefit Card 3 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10 relative overflow-hidden group" data-id="element-349">
            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-bl-full -mr-12 -mt-12 group-hover:scale-110 transition-transform duration-500" data-id="element-350"></div>
            <div className="flex items-center mb-4" data-id="element-351">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-352">
                <BookOpenIcon className="w-6 h-6 text-white" data-id="element-353" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-354">
                Exclusive CPD package, including free Craig Barton's online
                courses
              </h3>
            </div>
            <p className="text-white/90" data-id="element-355">
              Comprehensive training and dedicated support from Eedi's team
              throughout the study, plus free access to Craig Barton's 90-minute
              online CPD workshops.
            </p>
          </div>
          {/* Benefit Card 4 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10 relative overflow-hidden group" data-id="element-356">
            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-bl-full -mr-12 -mt-12 group-hover:scale-110 transition-transform duration-500" data-id="element-357"></div>
            <div className="flex items-center mb-4" data-id="element-358">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-359">
                <GraduationCapIcon className="w-6 h-6 text-white" data-id="element-360" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-361">Free STAR Maths Assessments</h3>
            </div>
            <p className="text-white/90 mb-2" data-id="element-362">
              Free access for all participating students to baseline, midline,
              and endline STAR maths assessments to track progress throughout
              the year.
            </p>
            <p className="text-white font-bold" data-id="element-363">Worth £££'s</p>
          </div>
          {/* Benefit Card 5 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10 relative overflow-hidden group" data-id="element-364">
            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-bl-full -mr-12 -mt-12 group-hover:scale-110 transition-transform duration-500" data-id="element-365"></div>
            <div className="flex items-center mb-4" data-id="element-366">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-367">
                <BarChart2Icon className="w-6 h-6 text-white" data-id="element-368" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-369">Insightful Progress Reports</h3>
            </div>
            <p className="text-white/90" data-id="element-370">
              Detailed data on class misconceptions and pupil progress to inform
              teaching and interventions. Includes actionable insights for
              targeted support.
            </p>
          </div>
          {/* Benefit Card 6 - Updated */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10 relative overflow-hidden group" data-id="element-371">
            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-bl-full -mr-12 -mt-12 group-hover:scale-110 transition-transform duration-500" data-id="element-372"></div>
            <div className="flex items-center mb-4" data-id="element-373">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-374">
                <HeartIcon className="w-6 h-6 text-white" data-id="element-375" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-376">
                Help Close The Maths Attainment Gap
              </h3>
            </div>
            <p className="text-white/90" data-id="element-377">
              Independent evaluations have already demonstrated that Eedi helps
              close the attainment gap by rapidly raising the performance of
              lower-attaining students. Your school will help bring this impact
              to more learners nationwide.
            </p>
          </div>
        </div>
      </div>
    </section>;
}